import { createFormData } from 'hooks';
import { fileActions } from './';
import {
    call,
    put,
    select,
    takeEvery
} from 'redux-saga/effects';
import fileServices, {
    downloadFileService
} from './services';

function* _createFile ({ payload }) {
    try {
        yield put(fileActions.setFileStatus('file-creating'));
        const { data } = yield call(fileServices.postFile, null, createFormData(payload));
        const { folder_id } = payload;
        const { file: { folders } } = yield select();
        const newFolders = folders.map(folder => {
            const { files, id } = folder;
            if (id === folder_id) {
                return ({
                    ...folder,
                    files: [data, ...files]
                });
            } else {
                return folder;
            }
        });
        yield put(fileActions.setFileFolders(newFolders));
        yield put(fileActions.setFileStatus('file-created'));
    } catch (e) {
        yield put(fileActions.setFileStatus(''));
    } finally {

    }
}

function* _createFolder ({ payload }) {
    try {
        yield put(fileActions.setFileBlocked(true));
        yield put(fileActions.setFileStatus('folder-creating'));
        const { data } = yield call(fileServices.postFolder, null, payload);
        const { file: { folders } } = yield select();
        const newFolders = [...folders, { ...data, files: [] }];
        yield put(fileActions.setFileFolders(newFolders));
        yield put(fileActions.setFileStatus('folder-created'));
    } catch (e) {
        yield put(fileActions.setFileStatus(''));
    } finally {
        yield put(fileActions.setFileBlocked(false));
    }
}

function* _deleteFolder ({ payload }) {
    try {
        yield put(fileActions.setFileBlocked(true));
        yield put(fileActions.setFileStatus('folder-deleting'));
        yield call(fileServices.deleteFolder, { folder_id: payload });
        const { file: { folders } } = yield select();
        const newFolders = folders.filter(({ id }) => id !== payload);
        yield put(fileActions.setFileStatus(`folder-deleted-${ payload }`));
        yield put(fileActions.setFileFolders(newFolders));
    } catch (e) {
        yield put(fileActions.setFileStatus(''));
    } finally {
        yield put(fileActions.setFileBlocked(false));
    }
}

function* _deleteFile ({ payload: { file_id, folder_id } }) {
    try {
        yield put(fileActions.setFileBlocked(true));
        yield put(fileActions.setFileStatus('file-deleting'));
        yield call(fileServices.deleteFile, { file_id });
        const { file: { folders } } = yield select();
        const newFolders = folders.map(folder => {
            const { files, id: search_id } = folder;
            if (search_id === folder_id) {
                return ({
                    ...folder,
                    files: files.filter(({ id }) => id !== file_id)
                });
            } else {
                return folder;
            }
        });
        yield put(fileActions.setFileStatus(`file-deleted-${ file_id }`));
        yield put(fileActions.setFileFolders(newFolders));
    } catch (e) {
        yield put(fileActions.setFileStatus(''));
    } finally {
        yield put(fileActions.setFileBlocked(false));
    }
}

function* _downloadFile ({ payload: { id, name } }) {
    try {
        yield call(downloadFileService, id, name);
    } catch (e) {

    }
}

function* _getFile ({ payload: { file_id, folder_id } }) {
    try {
        yield put(fileActions.setFileStatus(`file-loading-${ file_id }`));
        const { data } = yield call(fileServices.fetchFile, { file_id });
        const { file: { folders } } = yield select();
        const newFolders = folders.map(folder => {
            const { id } = folder;
            if (id !== folder_id) {
                return folder;
            } else {
                const { files } = folder;
                return ({
                    ...folder,
                    files: files.map(file => {
                        const { id: search_id } = file;
                        if (search_id !== file_id) {
                            return file;
                        } else {
                            return data;
                        }
                    })
                });
            }
        });
        yield put(fileActions.setFileFolders(newFolders));
    } catch (e) {

    } finally {
        yield put(fileActions.setFileStatus(''));
    }
}

function* _getFileFolders ({ payload }) {
    try {
        yield put(fileActions.setFileLoading(true));
        const { data } = yield call(fileServices.fetchFolders, { patient_id: payload });
        yield put(fileActions.setFileFolders(data));
    } catch (e) {
        yield put(fileActions.setFileFolders([]));
    } finally {
        yield put(fileActions.setFileLoading(false));
    }
}

function* _updateFile ({ payload: { folder_id, id, ...body } }) {
    try {
        yield put(fileActions.setFileBlocked(true));
        const { data } = yield call(fileServices.putFile, { id }, body);
        const { file: { folders } } = yield select();
        const newFolders = [...folders];
        const index = newFolders.findIndex(({ id }) => id === folder_id);
        const fileIndex = newFolders[index].files.findIndex(({ id: file_id }) => id === file_id);
        const newFiles = [...newFolders[index].files];
        newFiles.splice(fileIndex, 1, data);
        newFolders[index] = { ...newFolders[index], files: newFiles };
        yield put(fileActions.setFileStatus(`file-updated-${ id }`));
        yield put(fileActions.setFileFolders(newFolders));
    } catch (e) {

    } finally {
        yield put(fileActions.setFileBlocked(false));
    }
}

function* _updateFolder ({ payload: { id, ...body } }) {
    try {
        yield put(fileActions.setFileBlocked(true));
        const { data } = yield call(fileServices.putFolder, { id }, body);
        const { file: { folders } } = yield select();
        const newFolders = [...folders];
        const index = newFolders.findIndex(({ id: folder_id }) => id === folder_id);
        newFolders[index] = { ...newFolders[index], ...data };
        yield put(fileActions.setFileStatus(`folder-updated-${ id }`));
        yield put(fileActions.setFileFolders(newFolders));
    } catch (e) {

    } finally {
        yield put(fileActions.setFileBlocked(false));
    }
}

export default [
    takeEvery(fileActions.createFile.type, _createFile),
    takeEvery(fileActions.createFolder.type, _createFolder),
    takeEvery(fileActions.deleteFile.type, _deleteFile),
    takeEvery(fileActions.deleteFolder.type, _deleteFolder),
    takeEvery(fileActions.downloadFile.type, _downloadFile),
    takeEvery(fileActions.getFile.type, _getFile),
    takeEvery(fileActions.getFileFolders.type, _getFileFolders),
    takeEvery(fileActions.updateFile.type, _updateFile),
    takeEvery(fileActions.updateFolder.type, _updateFolder)
];
